import React from 'react'
import loader from './loader.png'
function DownloadLoader(props) {
  return (
    <img src={loader} className="animate-spin" />
  )
}

export default DownloadLoader
